/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const NotificationContext = createContext(null);

export function NotificationProvider({ children }) {
  const [items, setItems] = useState([]); // {id, titulo, texto, tipo, remetente, date, read, sticky}

  const add = useCallback((msg) => {
    const id = crypto.randomUUID?.() || String(Date.now() + Math.random());
    const item = {
      id,
      titulo: msg?.titulo || 'Mensagem',
      texto: msg?.texto || '',
      tipo: (msg?.tipo || 'info').toLowerCase(), // info | warn | warning | error | bloqueio
      remetente: msg?.remetente || 'Sistema',
      date: msg?.dataHora ? new Date(msg.dataHora) : new Date(),
      sticky: !!msg?.sticky,
      read: false,
    };
    setItems((prev) => [item, ...prev]);
    return id;
  }, []);

  const markRead = useCallback((id, read = true) => {
    setItems((prev) => prev.map((n) => (n.id === id ? { ...n, read } : n)));
  }, []);

  const markAllRead = useCallback(() => {
    setItems((prev) => prev.map((n) => ({ ...n, read: true })));
  }, []);

  const remove = useCallback((id) => {
    setItems((prev) => prev.filter((n) => n.id !== id));
  }, []);

  const clearNonSticky = useCallback(() => {
    setItems((prev) => prev.filter((n) => n.sticky));
  }, []);

  const value = useMemo(
    () => ({ items, add, markRead, markAllRead, remove, clearNonSticky }),
    [items, add, markRead, markAllRead, remove, clearNonSticky]
  );

  return <NotificationContext.Provider value={value}>{children}</NotificationContext.Provider>;
}

export function useNotifications() {
  const ctx = useContext(NotificationContext);
  if (!ctx) throw new Error('useNotifications deve estar dentro de <NotificationProvider>');
  return ctx;
}
